module.exports = {"420804001":"掇刀石街道","420804002":"白庙街道","420804003":"兴隆街道","420804004":"双喜街道","420804100":"团林铺镇","420804101":"麻城镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420804.json
// module id = 1874
// module chunks = 0